import { render, staticRenderFns } from "./RecommendProductsList.vue?vue&type=template&id=4fbe4b60&scoped=true&"
import script from "./RecommendProductsList.vue?vue&type=script&lang=js&"
export * from "./RecommendProductsList.vue?vue&type=script&lang=js&"
import style0 from "./RecommendProductsList.vue?vue&type=style&index=0&id=4fbe4b60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbe4b60",
  null
  
)

export default component.exports